import React from 'react';

import {
  Switch,
  Route,
} from "react-router-dom";

function SubRouter(props) {
  let prefix = props.conf.prefix;
  return (
    <>
      <Switch>
        {Object.keys(props.conf.routes).map((key) => {
          let item = props.conf.routes[key];
          if(item.type === 'component') {
            return (
              <Route key={key} exact={item.exact} path={`${prefix}${item.path}`} component={item.getComponent()}/>
            );
          }
          else if (item.type === 'render') {
            return (
              <Route key={key} exact={item.exact} path={`${prefix}${item.path}`} render={item.getRender}/>
            );
          }
          else {
            throw new Error("invalid type inside router");
          }
        })}
      </Switch>
    </>
  );
}

export default SubRouter;
